import { HEADER_HEIGHT } from "../../constants/core-constants";
import { ColorsEnum } from "../../core/et3-theme/colors";

export { HEADER_HEIGHT };

const ALPHA_HAIRLINE = "14";
const ALPHA_HOVER = "0A";
const ALPHA_ACTIVE = "14";
const ALPHA_BADGE = "1F";
const ALPHA_SHADOW = "0D";

export const HEADER_WIDTH = 1920;
export const HEADER_PADDING_X = 28;

export const HEADER_BRAND_WIDTH = 300;
export const HEADER_LOGO_SIZE = 150;

export const HEADER_MENU_WIDTH = 1564;
export const HEADER_MENU_HEIGHT = HEADER_HEIGHT;
export const HEADER_MENU_GAP = 6;

export const HEADER_ITEM_HEIGHT = 44;
export const HEADER_ITEM_PADDING_X = 18;
export const HEADER_ITEM_RADIUS = 10;
export const HEADER_ITEM_GAP = 8;
export const HEADER_LABEL_FONT_SIZE = 18;

export const HEADER_BADGE_HEIGHT = 22;
export const HEADER_BADGE_PADDING_X = 7;
export const HEADER_BADGE_RADIUS = 11;
export const HEADER_BADGE_FONT_SIZE = 12;

export const HEADER_ALERT_HEIGHT = 44;
export const HEADER_ALERT_FONT_SIZE = 20;

export const HEADER_UTILITIES_WIDTH = 640;
export const HEADER_UTILITIES_GAP = 10;
export const HEADER_CHIP_HEIGHT = 32;
export const HEADER_CHIP_RADIUS = 8;
export const HEADER_CHIP_PADDING_X = 12;
export const HEADER_CHIP_GAP = 8;
export const HEADER_CHIP_FONT_SIZE = 14;
export const HEADER_CHIP_ICON_SIZE = 13;
export const HEADER_CHIP_LOADER_WIDTH = 40;

export const HEADER_PROFILE_HEIGHT = 44;
export const HEADER_PROFILE_AVATAR_SIZE = 30;
export const HEADER_PROFILE_RADIUS = 10;
export const HEADER_PROFILE_PADDING_X = 10;
export const HEADER_PROFILE_GAP = 9;
export const HEADER_PROFILE_FONT_SIZE = 16;
export const HEADER_PROFILE_CHEVRON_SIZE = 12;
export const HEADER_PROFILE_LEADING_GAP = 6;

export const HEADER_CHIP_BACKGROUND = `${ColorsEnum.maastrichtBlue}${ALPHA_HOVER}`;
export const HEADER_CHIP_PRODUCTION_BACKGROUND = `${ColorsEnum.red}${ALPHA_BADGE}`;
export const HEADER_CHIP_PREPROD_BACKGROUND = `${ColorsEnum.darkOrange}${ALPHA_BADGE}`;
export const HEADER_CHIP_STAGING_BACKGROUND = `${ColorsEnum.purple}${ALPHA_BADGE}`;
export const HEADER_CHIP_DEVELOPMENT_BACKGROUND = `${ColorsEnum.bondiBlue}${ALPHA_BADGE}`;

export const HEADER_BORDER = `1px solid ${ColorsEnum.maastrichtBlue}${ALPHA_HAIRLINE}`;
export const HEADER_SHADOW = `0 1px 2px ${ColorsEnum.maastrichtBlue}${ALPHA_SHADOW}`;
export const HEADER_ITEM_HOVER_BACKGROUND = `${ColorsEnum.maastrichtBlue}${ALPHA_HOVER}`;
export const HEADER_ITEM_ACTIVE_BACKGROUND = `${ColorsEnum.bondiBlue}${ALPHA_ACTIVE}`;
export const HEADER_BADGE_BACKGROUND = `${ColorsEnum.bondiBlue}${ALPHA_BADGE}`;
export const HEADER_TRANSITION =
  "background-color 160ms cubic-bezier(0.4, 0, 0.2, 1), color 160ms cubic-bezier(0.4, 0, 0.2, 1)";

export const HEADER_COMPACT_BREAKPOINT = 1150;
export const HEADER_COMPACT_ITEM_PADDING_X = 11;
export const HEADER_COMPACT_LABEL_FONT_SIZE = 16;
export const HEADER_COMPACT_CHIP_HEIGHT = 24;
export const HEADER_COMPACT_CHIP_FONT_SIZE = 12;
export const HEADER_COMPACT_CHIP_PADDING_X = 9;
export const HEADER_ACCENT_HEIGHT = 2;
export const HEADER_TAB_UNDERLINE_HEIGHT = 3;
export const HEADER_TAB_UNDERLINE_WIDTH = 22;
export const HEADER_DOT_SIZE = 8;
export const HEADER_DIVIDER_WIDTH = 1;
export const HEADER_DIVIDER_HEIGHT = 14;
export const HEADER_SESSION_GAP = 9;
export const HEADER_SESSION_COLLAPSED_WIDTH = 42;
export const HEADER_SESSION_EXPANDED_WIDTH = 460;
export const HEADER_SESSION_EXPAND_TRANSITION =
  "max-width 260ms cubic-bezier(0.4, 0, 0.2, 1), background-color 160ms cubic-bezier(0.4, 0, 0.2, 1)";
export const HEADER_SESSION_CONTENT_TRANSITION =
  "opacity 180ms cubic-bezier(0.4, 0, 0.2, 1)";

export const HEADER_ACCENT_GRADIENT = `linear-gradient(90deg, ${ColorsEnum.bondiBlue} 0%, ${ColorsEnum.purple} 55%, ${ColorsEnum.vibrantPinkishMagenta} 100%)`;
export const HEADER_BRAND_BACKDROP = `radial-gradient(circle at 22% 18%, ${ColorsEnum.bondiBlue}59 0%, ${ColorsEnum.bondiBlue}00 62%), radial-gradient(circle at 88% 92%, ${ColorsEnum.shadeOfBlueDark}4D 0%, ${ColorsEnum.shadeOfBlueDark}00 60%)`;
export const HEADER_LOGO_MONOCHROME_FILTER = "brightness(0) invert(1)";
export const HEADER_ON_DARK_BACKGROUND = `${ColorsEnum.borderBlue}14`;
export const HEADER_ON_DARK_DIVIDER = `${ColorsEnum.borderBlue}3D`;
